import Plettac from "./Plettac";

export default Plettac;
